//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconStatusStatus(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM4.09941 10.7353C4.70567 6.91797 8.01207 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.82962 20 4.40455 16.8089 4.03334 12.7353H7.68809H8.24532L9.90989 10.0455L13.734 17.6424L16.4449 12.7353H18.2575V10.7353H15.2648L13.8162 13.3576L10.0896 5.95448L7.13103 10.7353H4.09941Z" fill="currentColor" /></svg>;
}
export default IconStatusStatus;